var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterface1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 69.82 70.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9caab2;}.cls-2{fill:#b8bcc0;}.cls-3{fill:#ccd6e5;}.cls-4{fill:#8ab3ff;}.cls-5{fill:#343f42;}.cls-6{fill:#588df0;}.cls-13,.cls-7{fill:none;stroke-miterlimit:10;}.cls-7{stroke:#588df0;}.cls-8{fill:#828282;}.cls-9{fill:#303b3e;}.cls-10{fill:#f44d4d;}.cls-11{fill:#f66562;}.cls-12{fill:#d0d6e2;}.cls-13{stroke:#303b3e;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_01b",
    "data-name": "Interface_01b",
    viewBox: "0 0 69.82 70.2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.97 25.2 69.82 5.76 69.82 50.76 9.97 70.2 9.97 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.97 25.2 0 19.45 0 64.45 9.97 70.2 9.97 25.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "69.82 5.76 9.97 25.2 0 19.45 59.85 0 69.82 5.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "17.63 35.77 52.27 24.52 52.2 52.43 17.63 63.67 17.63 35.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.26,25.89,51.2,51.71,18.62,62.29V36.5L51.26,25.89m2-2.75L16.62,35V65L53.2,53.16l.07-30Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "39.9 33.48 49.87 30.24 49.87 48.24 39.9 51.48 39.9 33.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 38.88,
    x2: 36.57,
    y2: 34.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 44.88,
    x2: 36.57,
    y2: 40.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 50.88,
    x2: 36.57,
    y2: 46.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 23.27,
    y1: 56.88,
    x2: 36.57,
    y2: 52.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "54.89 22.61 54.89 52.61 64.86 49.37 64.86 19.37 54.89 22.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.45,31.31a2.72,2.72,0,0,1-2.75-2.82,4.53,4.53,0,0,1,3.06-4.1,3.67,3.67,0,0,1,1.07-.17A2.72,2.72,0,0,1,23.57,27a4.53,4.53,0,0,1-3.06,4.1A3.66,3.66,0,0,1,19.45,31.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.94,27.55l-3.2-1.85a1.78,1.78,0,0,0-1.6-.17,3.36,3.36,0,0,0-2.23,3,1.6,1.6,0,0,0,.52,1.25L22,31.84a1.81,1.81,0,0,0,1.44.07A3.35,3.35,0,0,0,25.69,29,1.54,1.54,0,0,0,24.94,27.55Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 23.46,
    cy: 29.68,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-14.35 28.32) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.42,28.07a2.72,2.72,0,0,1-2.74-2.82,4.51,4.51,0,0,1,3.06-4.1A3.61,3.61,0,0,1,30.8,21a2.72,2.72,0,0,1,2.74,2.82,4.51,4.51,0,0,1-3.06,4.1A3.61,3.61,0,0,1,29.42,28.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M34.92,24.31l-3.21-1.85a1.77,1.77,0,0,0-1.6-.17,3.37,3.37,0,0,0-2.23,3,1.59,1.59,0,0,0,.53,1.25L32,28.6a1.83,1.83,0,0,0,1.45.07,3.35,3.35,0,0,0,2.23-3A1.56,1.56,0,0,0,34.92,24.31Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 33.44,
    cy: 26.44,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-8.37 34.78) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.49,25.15a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52A4.26,4.26,0,0,1,38.46,25,3.34,3.34,0,0,1,37.49,25.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 38.18,
    cy: 21.9,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-3.24 36.79) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M44.14,23a2.4,2.4,0,0,1-2.44-2.52,4.25,4.25,0,0,1,2.85-3.81,3,3,0,0,1,1-.16A2.4,2.4,0,0,1,48,19a4.26,4.26,0,0,1-2.85,3.81A3.39,3.39,0,0,1,44.14,23Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 44.83,
    cy: 19.74,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(0.75 41.1) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M50.79,20.83a2.4,2.4,0,0,1-2.44-2.52,4.27,4.27,0,0,1,2.85-3.82,3.32,3.32,0,0,1,1-.15,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.39,3.39,0,0,1,50.79,20.83Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 51.48,
    cy: 17.58,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(4.73 45.4) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,30.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,30.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 26.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(0.72 55.16) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,39.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,39.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 35.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-6.13 58.33) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.35,48.05a2.4,2.4,0,0,1-2.45-2.52,4.26,4.26,0,0,1,2.86-3.81,3,3,0,0,1,1-.16,2.4,2.4,0,0,1,2.44,2.52,4.26,4.26,0,0,1-2.85,3.81A3.27,3.27,0,0,1,59.35,48.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 60.03,
    cy: 44.8,
    rx: 2.62,
    ry: 1.9,
    transform: "translate(-12.99 61.5) rotate(-49.61)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 32.64,
    x2: 63.17,
    y2: 30.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 41.47,
    x2: 63.17,
    y2: 39.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 56.52,
    y1: 50.6,
    x2: 63.17,
    y2: 48.44
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 69.82,
    height: 70.21,
    xlinkHref: "#Interface_01b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterface1);
export default __webpack_public_path__ + "static/media/interface-1.7a75064b3a76935e31b53e198c5b2cdd.svg";
export { ForwardRef as ReactComponent };